/* eslint-disable */

/** GENERATED FILE. Do not edit. To regenerate: yarn run write-app-config-source **/
export var AFFIRM_PUBLIC_KEY_AU = process.env.AFFIRM_PUBLIC_KEY_AU;
export var AFFIRM_PUBLIC_KEY_CA = process.env.AFFIRM_PUBLIC_KEY_CA;
export var AFFIRM_PUBLIC_KEY_US = process.env.AFFIRM_PUBLIC_KEY_US;
export var AFFIRM_SCRIPT_URL_AU = process.env.AFFIRM_SCRIPT_URL_AU;
export var AFFIRM_SCRIPT_URL_CA = process.env.AFFIRM_SCRIPT_URL_CA;
export var AFFIRM_SCRIPT_URL_US = process.env.AFFIRM_SCRIPT_URL_US;
export var ALLOW_COPY_XRAY = Boolean(process.env.ALLOW_COPY_XRAY);
export var ALLOW_DATE_TRIGGER_PANEL = Boolean(process.env.ALLOW_DATE_TRIGGER_PANEL);
export var ALLOW_FEATURE_TOGGLES = Boolean(process.env.ALLOW_FEATURE_TOGGLES);
export var ALLOW_MWI_PREVIEW_INSTRUCTOR_PAGES = Boolean(process.env.ALLOW_MWI_PREVIEW_INSTRUCTOR_PAGES);
export var ALLOW_PREVIEW_COPY = Boolean(process.env.ALLOW_PREVIEW_COPY);
export var ALLOW_PROMO_PANEL = Boolean(process.env.ALLOW_PROMO_PANEL);
export var ALLOW_SANDBOX_ROUTES = Boolean(process.env.ALLOW_SANDBOX_ROUTES);
export var ALLOW_TOGGLE_PANEL = Boolean(process.env.ALLOW_TOGGLE_PANEL);
export var BUILD_TIME_GRAPHQL_URI = process.env.BUILD_TIME_GRAPHQL_URI;
export var CLOUDINARY_ACCOUNT = process.env.CLOUDINARY_ACCOUNT;
export var COMMERCETOOLS_API_URL = process.env.COMMERCETOOLS_API_URL;
export var COMMERCETOOLS_APPAREL_CATEGORY_ID = process.env.COMMERCETOOLS_APPAREL_CATEGORY_ID;
export var COMMERCETOOLS_AUTH_URL = process.env.COMMERCETOOLS_AUTH_URL;
export var COMMERCETOOLS_CLIENT_ID = process.env.COMMERCETOOLS_CLIENT_ID;
export var COMMERCETOOLS_CLIENT_ID_PROD = process.env.COMMERCETOOLS_CLIENT_ID_PROD;
export var COMMERCETOOLS_CLIENT_SECRET = process.env.COMMERCETOOLS_CLIENT_SECRET;
export var COMMERCETOOLS_CLIENT_SECRET_PROD = process.env.COMMERCETOOLS_CLIENT_SECRET_PROD;
export var COMMERCETOOLS_INVENTORY_CHANNEL_ID = process.env.COMMERCETOOLS_INVENTORY_CHANNEL_ID;
export var COMMERCETOOLS_MARKDOWN_CHANNEL_ID = process.env.COMMERCETOOLS_MARKDOWN_CHANNEL_ID;
export var COMMERCETOOLS_PROJECT_KEY = process.env.COMMERCETOOLS_PROJECT_KEY;
export var COMMERCETOOLS_PROJECT_KEY_PROD = process.env.COMMERCETOOLS_PROJECT_KEY_PROD;
export var COMMERCETOOLS_REGION = process.env.COMMERCETOOLS_REGION;
export var COMMERCETOOLS_REGION_PROD = process.env.COMMERCETOOLS_REGION_PROD;
export var COMMERCETOOLS_WEB_CHANNEL_ID = process.env.COMMERCETOOLS_WEB_CHANNEL_ID;
export var COMMIT_REF = process.env.COMMIT_REF;
export var CONTENTFUL_WWW_PREVIEW_TOKEN = process.env.CONTENTFUL_WWW_PREVIEW_TOKEN;
export var CONTENTFUL_WWW_PROD_TOKEN = process.env.CONTENTFUL_WWW_PROD_TOKEN;
export var DRIFT_KEY = process.env.DRIFT_KEY;
export var GOOGLE_GEOLOCATION_API_KEY = process.env.GOOGLE_GEOLOCATION_API_KEY;
export var GRAPHQL_ENDPOINT = process.env.GRAPHQL_ENDPOINT;
export var GRAPHQL_HOST = process.env.GRAPHQL_HOST;
export var MONITORING_ENV = process.env.MONITORING_ENV;
export var MWYIRESULTS_ACCOUNT_PASSWORD = process.env.MWYIRESULTS_ACCOUNT_PASSWORD;
export var MWYIRESULTS_ACCOUNT_USERNAME = process.env.MWYIRESULTS_ACCOUNT_USERNAME;
export var MWYIRESULTS_REST_API_BASEURL = process.env.MWYIRESULTS_REST_API_BASEURL;
export var NO_INDEX = Boolean(process.env.NO_INDEX);
export var ONEPELOTON_API_URL = process.env.ONEPELOTON_API_URL;
export var ONEWELLNESS_OAUTH_CLIENT_ID = process.env.ONEWELLNESS_OAUTH_CLIENT_ID;
export var ONEWELLNESS_OAUTH_DOMAIN = process.env.ONEWELLNESS_OAUTH_DOMAIN;
export var ONEWELLNESS_PROD_BENEFIT_AUTH_TOKEN = process.env.ONEWELLNESS_PROD_BENEFIT_AUTH_TOKEN;
export var ONEWELLNESS_UAT_BENEFIT_AUTH_TOKEN = process.env.ONEWELLNESS_UAT_BENEFIT_AUTH_TOKEN;
export var ONEWELLNESS_UAT_CF_ACCESS_CLIENT_ID = process.env.ONEWELLNESS_UAT_CF_ACCESS_CLIENT_ID;
export var ONEWELLNESS_UAT_CF_ACCESS_CLIENT_SECRET = process.env.ONEWELLNESS_UAT_CF_ACCESS_CLIENT_SECRET;
export var ONE_TRUST_KEY = process.env.ONE_TRUST_KEY;
export var OPTIMIZELY_DATAFILE = process.env.OPTIMIZELY_DATAFILE;
export var OPTIMIZELY_FULLSTACK_SDK_KEY = process.env.OPTIMIZELY_FULLSTACK_SDK_KEY;
export var OPTIMIZELY_KEY = process.env.OPTIMIZELY_KEY;
export var PB_CF_CMA_TOKEN = process.env.PB_CF_CMA_TOKEN;
export var PB_CF_DELIVERY_ACCESS_TOKEN = process.env.PB_CF_DELIVERY_ACCESS_TOKEN;
export var PB_CF_ENV = process.env.PB_CF_ENV;
export var PB_CF_PREVIEW_ACCESS_TOKEN = process.env.PB_CF_PREVIEW_ACCESS_TOKEN;
export var PB_CF_SPACE_ID = process.env.PB_CF_SPACE_ID;
export var PRODUCTION = process.env.PRODUCTION;
export var REACT_APP_API_ENV = process.env.REACT_APP_API_ENV;
export var REACT_APP_PRIVATE_ENV = process.env.REACT_APP_PRIVATE_ENV;
export var RECAPTCHA_ENTERPRISE_KEY = process.env.RECAPTCHA_ENTERPRISE_KEY;
export var RELOAD_NEXT_ROUTES = Boolean(process.env.RELOAD_NEXT_ROUTES);
export var SEGMENT_KEY = process.env.SEGMENT_KEY;
export var STRIPE_API_KEY = process.env.STRIPE_API_KEY;
export var TLD = process.env.TLD;